export default class {
  constructor(props) {
    const {action, cb} = props
    this.action = action
    this.cb = cb
    this.moving = false 

    this.progress = null
  }

  dispose() {
    this.action = null
  }

  update = () => {
    if(!this.action) return
    const progress = this.action.time / this.action._clip.duration

    if(progress !==  this.progress) {
      this.progress = progress
      this.moving = true
      this.cb(progress, this.moving)    
    } else if(this.moving) {
      this.moving = false
      this.cb(progress, this.moving)
    }
  }
}